module.exports = __webpack_public_path__ + "static/media/insect(41).289e75bc.PNG";